import React, {useState} from 'react';
import {EditOutlined, PlusOutlined} from '@ant-design/icons';
import {Button, Form, Input, Modal} from 'antd';
import {createD365HoursCategory, updateD365HoursCategory} from '../../api/d365Api';

const HoursCategoryButton = ({
                               disabled,
                               onCompleted,
                               isEdit,
                               title,
                               categoryID,
                               categoryName,
                               categoryCode,
                               style
                             }) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [form] = Form.useForm();

  const FORM_CATEGORY_NAME = 'category_name';
  const FORM_CATEGORY_CODE = 'category_code';

  const _createCategory = async () => {
    try {
      setLoading(true);
      const categoryName = form.getFieldValue(FORM_CATEGORY_NAME);
      const categoryCode = form.getFieldValue(FORM_CATEGORY_CODE);
      const action = isEdit ? "updated" : "created";
      const response = isEdit ?
        await updateD365HoursCategory(categoryID, categoryName, categoryCode) :
        await createD365HoursCategory(categoryName, categoryCode);
      onCompleted(response, action);
    } catch (e) {
      console.error(`Could not create D365 hours category`);
    } finally {
      setLoading(false);
      setShowModal(false);
      form.resetFields();
    }
  };

  return (
    <>
      <Button onClick={() => setShowModal(true)} loading={loading} disabled={disabled}
              icon={isEdit ? <EditOutlined/> : <PlusOutlined/>} style={style}>
        {title}
      </Button>


      <Modal
        title={(isEdit ? 'Edit' : 'Create') + ' Category Information'}
        open={showModal}
        onOk={() => setShowModal(false)}
        onCancel={() => setShowModal(false)}
        footer={[
          <Button key="cancel" onClick={() => setShowModal(false)}>Cancel</Button>,
          <Button key="submit" type="primary" onClick={() => form.submit()}
                  loading={loading}>Submit</Button>
        ]}
      >
        <Form
          name={`input_category`}
          form={form}
          onFinish={_createCategory}
          labelCol={{span: 6}}
          fields={[
            {
              name: [FORM_CATEGORY_NAME],
              value: isEdit ? categoryName : ""
            },
            {
              name: [FORM_CATEGORY_CODE],
              value: isEdit ? categoryCode : ""
            }
          ]}
        >
          <Form.Item
            label="Category Name"
            name={FORM_CATEGORY_NAME}
            rules={[{required: true}]}
          >
            <Input
              type="text"
              placeholder="Category Name"
            />
          </Form.Item>
          <Form.Item
            label="Category Code"
            name={FORM_CATEGORY_CODE}
            rules={[{
              required: true, pattern: new RegExp("NH\\d{4}"),
              message: "Code does not match pattern"
            }]}
          >
            <Input
              type="text"
              placeholder="Category Code"
            />
          </Form.Item>
        </Form>
      </Modal>

    </>
  );
};

export {HoursCategoryButton};